<template>
  <v-card>
    <v-card-title>{{ $t("Lisää pääkäyttäjä") }}</v-card-title>
    <v-card-text>
      <v-text-field
        :label="$t('Hae käyttäjää')"
        :placeholder="$t('Kirjoita nimi tai sähköposti')"
        :value="searchInput"
        @input="onSearchInput"
        :loading="searching"
        outlined
        clearable
        hide-details="auto"
        autofocus
      />

      <v-list v-if="candidates.length" class="mt-3 search-results" dense>
        <v-list-item
          v-for="item in candidates"
          :key="item.id"
    
          @click="selectedUserId = item.id"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">
              {{ item.last_name }} {{ item.first_name }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.email || item.title">
              {{ [item.title, item.email].filter(Boolean).join(' · ') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="selectedUserId === item.id">
            <v-icon color="primary">{{ icons.mdiCheck }}</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <div
        v-else-if="searchInput && searchInput.length > 1 && !searching"
        class="text--secondary mt-3"
      >
        {{ $t("Ei tuloksia") }}
      </div>

      <v-alert v-if="errorMessage" type="error" text class="mt-4" dense>
        {{ errorMessage }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancel')" :disabled="submitting">
        {{ $t("Peruuta") }}
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!selectedUserId || submitting"
        :loading="submitting"
        @click="promote"
      >
        {{ $t("Lisää pääkäyttäjäksi") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import { mdiCheck } from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";
import adminApi from "@/api/admin";

export default {
  props: {
    existingMainUserIds: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { t } = useTranslations();
    const searchInput = ref("");
    const candidates = ref([]);
    const selectedUserId = ref(null);
    const searching = ref(false);
    const submitting = ref(false);
    const errorMessage = ref("");

    let searchTimeout = null;
    const onSearchInput = (q) => {
      searchInput.value = q || "";
      selectedUserId.value = null;
      clearTimeout(searchTimeout);
      if (!q || q.length < 2) {
        candidates.value = [];
        return;
      }
      searchTimeout = setTimeout(async () => {
        searching.value = true;
        try {
          const resp = await adminApi.getUsers(1, 20, q);
          if (resp.ok) {
            const existing = new Set(props.existingMainUserIds);
            candidates.value = resp.data.results.filter(
              (u) => u.is_active && !existing.has(u.id)
            );
          }
        } finally {
          searching.value = false;
        }
      }, 300);
    };

    const promote = async () => {
      if (!selectedUserId.value) return;
      submitting.value = true;
      errorMessage.value = "";
      try {
        const resp = await adminApi.promoteMainUser(selectedUserId.value);
        if (resp.ok) {
          emit("promoted", resp.data);
        } else {
          errorMessage.value =
            (resp.data && resp.data.detail) ||
            t("Pääkäyttäjän lisääminen epäonnistui");
        }
      } finally {
        submitting.value = false;
      }
    };

    return {
      searchInput,
      candidates,
      selectedUserId,
      searching,
      submitting,
      errorMessage,
      onSearchInput,
      promote,
      icons: { mdiCheck },
      t,
    };
  },
};
</script>

<style scoped>
.search-results {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
</style>
